(function($) {

var pageId = 'page-calendar-event',
    page = '#' + pageId,
    isSchedule = null;

$(function() {
    $(document)
        .on('click', page + ' .detail-action-del', deleteEventClick)
        .on('click', '.page-calendar-remove-popover .period-destroy-confirm .btn', periodDestroyDecision);
});

function deleteEventClick( e ) {
    e.preventDefault();

    var link = $( this );

    if (isSchedule) {
        var confirmContent = $(simple.tpl($('#tpl-period-destroy-confirm').html()));
        simple.popover({
            pointTo: link,
            content: confirmContent,
            cls: 'page-calendar-remove-popover',
            position: "left-middle"
        });
    } else {
        simple.dialog.confirm({
            content: "确定要删除这条日程吗？",
            callback: function(e, yes) {
                if ( !yes ) {
                    return;
                }
                deleteEvent(link);
            }
        });
    }
}

function periodDestroyDecision(e) {
    e.preventDefault();

    var btn = $(this),
        link = $('.detail-action-del');

    if (btn.is('.btn-yes')) {
        deleteEvent(link, {repeat_modify: 1});
    } else if (btn.is('.btn-no')) {
        deleteEvent(link, {repeat_modify: 0});
    } else if (btn.is('.btn-nevermind')) {
        link.data('popover').destroy();
    }
}

function deleteEvent(link, extraParams) {
    var data = {};
    var loading = simple.loading({
        type: 'global',
        msg: '正在删除日程...'
    });

    if (extraParams) {
        $.extend(data, extraParams);
    }

    $.ajax({
        type: "post",
        url: link.data( "url" ),
        data: data,
        success: function(result) {
            loading.destroy();
            tower.stack.load(link.data('goto'), {
                root: true,
                fluid: true
            });
        }
    });
}

$(document).on('pjaxload#' + pageId, function(e, $page, page) {
    isSchedule = $('.calendar-event').data('schedule');

    // to be fixed
    //var sheetRoot = $page.parent('.page').closest('.sheet-root');
    //if (sheetRoot.data('id') === 'page-project') {
        //$page.find('.detail-action-del').attr('data-goto', sheetRoot.data('url'));
    //}

    var $eventAlert = $page.find('.event-alert');
    var alertTime = $eventAlert.data('time');
    if (alertTime) {
        alertTime = moment(alertTime);
        var startTime = moment($page.find('.event-time .start-time').data('time'));
        var $eventAlert = $page.find('.event-alert');
        if (startTime.diff(alertTime, 'm') == 0) {
            $eventAlert.text('日程开始时');
        } else if (startTime.diff(alertTime, 'm') == 5) {
            $eventAlert.text('提前五分钟');
        } else if (startTime.diff(alertTime, 'm') == 15) {
            $eventAlert.text('提前十五分钟');
        } else if (startTime.diff(alertTime, 'm') == 30) {
            $eventAlert.text('提前三十分钟');
        } else if (startTime.diff(alertTime, 'h') == 1) {
            $eventAlert.text('提前一小时');
        } else if (startTime.diff(alertTime, 'h') == 2) {
            $eventAlert.text('提前两小时');
        } else if (startTime.diff(alertTime, 'd') == 1) {
            $eventAlert.text('提前一天');
        } else if (startTime.diff(alertTime, 'd') == 2) {
            $eventAlert.text('提前两天');
        } else if (startTime.diff(alertTime, 'w') == 1) {
            $eventAlert.text('提前一周');
        }
    }

    // show event time unless it's a all day event
    //var $startTime = $page.find('.event-time .start-time');
    //var $endTime = $page.find('.event-time .end-time');
    //var startTime = moment($startTime.data('time'));
    //var endTime = moment($endTime.data('time'));
    //var dayStart = startTime.clone().startOf('d');
    //var dayEnd = endTime.clone().endOf('d');
    //if (dayStart.isSame(startTime) && dayEnd.isSame(endTime, 'm')) {
        //if (startTime.isSame(endTime, 'd')) {
            //$endTime.hide();
        //}
    //} else {
        //$startTime.text(startTime.format('M月D日 HH:mm'));
        //$endTime.text(endTime.format('- M月D日 HH:mm'));
    //}

    tower.adjustAuthor();
    tower.adjustAttachment();
    tower.adjustCommentEvents();
    tower.adjustCommentsLike();
    tower.foldComments();
});


})(jQuery);

